import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@material-ui/core";

const ErrorModal = props => (
  <Dialog
    open={props.errorModalOpen}
    aria-labelledby="error-modal-dialog-title"
    aria-describedby="error-modal-dialog-description"
  >
    <DialogTitle style={{ textAlign: "center" }} id="alert-dialog-title">
      {props.type}
    </DialogTitle>
    <DialogContent id="error-modal-dialog-description">
      <Typography
        variant="body1"
        color="textSecondary"
        component="p"
        style={{
          whiteSpace: "pre-line",
          fontSize: "16px"
        }}
      >
        {props.errorMessage}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={props.onErrorModalClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

ErrorModal.propTypes = {
  errorModalOpen: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  onErrorModalClose: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};

ErrorModal.defaultProps = {
  errorMessage: "Error"
};

export default ErrorModal;
